import useBreadcrumbs from "use-react-router-breadcrumbs";
import React, { useMemo } from "react";
import { PageItem } from "./PageItem";
import {
  useCarbonProjectsSelector,
  useSelectedRecommendedProjectSelector,
} from "../../store/projects/selectors";
import { TCarbonProjectData } from "../../types";
import { useLocation, useParams } from "react-router-dom";

const useProjectData = (): string | undefined => {
  const {
    data: { items: carbonProjects },
  } = useCarbonProjectsSelector();

  const projectData = useSelectedRecommendedProjectSelector();

  const location = useLocation();

  const carbonProjectData: TCarbonProjectData[] = carbonProjects;
  const { id } = useParams<{ id: string }>();

  return useMemo(() => {
    if (location.pathname.includes("recommendation")) {
      return projectData?.adm2 ?? projectData?.adm_name;
    } else {
      const project = carbonProjectData.find((project) => project.properties.id.toString() === id);
      return project?.properties.name;
    }
  }, [projectData, carbonProjectData, id]);
};

export const Breadcrumb = () => {
  const breadcrumbs = useBreadcrumbs();
  const projectName = useProjectData();

  return (
    <div className="text-g flex gap-2">
      {breadcrumbs.slice(1).map(({ match }, index) => (
        <PageItem
          key={`breadcrumb-page-${index}`}
          pageName={getPageName(match.pathname, projectName)}
          className={`${
            index === breadcrumbs.length - 2 ? "text-gray-700" : "text-primaryPurple-100"
          }`}
          isFirstItem={index === 0}
        />
      ))}
    </div>
  );
};

const getPageName = (pathname: string, projectName: string | undefined): string => {
  if (pathname === "/project") {
    return "Projects";
  }
  if (pathname === "/recommendation") {
    return "Recommendations";
  }

  if (pathname.startsWith("/project/") && projectName) {
    return projectName;
  } else if (pathname.startsWith("/recommendation/") && projectName) {
    return projectName;
  }
  return "Unknown Page";
};
